import React from 'react';
import i18n from '@fe/i18n/dist/i18n';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';

const cx = cls(styles);

/**
 * 模板
 * @param str
 * @param data
 * @returns
 */
function template(str: string, data: Record<string, any>) {
  return str.replace(/\{([0-9a-zA-Z_]+)\}/g, (match, key) => {
    if (data && match && Object.prototype.hasOwnProperty.call(data, key)) {
      return data[key];
    }
    return '';
  });
}

const ItemMap = [
  {
    icon: 'i1',
    title: 'Founded in',
    txt: '2014'
  },
  {
    icon: 'i2',
    title: 'Headquartered of {country} in',
    txt: 'location',
    i18n: true
  },
  {
    icon: 'i3',
    title: 'Capitalized with',
    txt: '$400 million'
  },
  {
    icon: 'i4',
    title: 'Paid students',
    txt: '500,000+ '
  }
];

const str = i18n.getMessages('landing');
/**
 * 办公场所
 */
export default function AddressBox() {
  const countryName = str('country_name');
  return (
    <div className={ cx('address-box') }>
      <Section>
        <h3 className={ cx('block-title', 'black') }>AirClass, #1 ranked online 1-on-1 tutoring school.</h3>
        {/*<p className={cx('tit-sub')}>listed on the NYSE in Jun 2021（code: ZME)</p>*/ }
        <div className={ cx('company-data') }>
          { ItemMap.map((item, idx) => {
            return (
              <div className={ cx('d-item') } key={ idx }>
                <i className={ cx('icon', item.icon) } />
                <span className={ cx('v') }>
									{ template(item.title, {
                    // hack !无敌的业务
                    country: countryName === 'Canada' ? 'CA' : countryName
                  }) }
								</span>
                <span className={ cx('num') }>{ item.i18n ? str(item.txt) : item.txt }</span>
              </div>
            );
          }) }
        </div>
        <div className={ cx('imgs', 'small', 'scroll-view') }>
          <div className={ cx('img-box') }>
            <img loading='lazy' alt='air-class'
                 src='https://web-data.zmlearn.com/image/mCe98giSsU7TdCA82T4uWA/pic1%402x.png' />
          </div>
          <div className={ cx('img-box') }>
            <img loading='lazy' alt='air-class'
                 src='https://web-data.zmlearn.com/image/coGfwJCQjFWezExsKGPcCe/pic2%402x.png' />
          </div>
          <div className={ cx('img-box') }>
            <img loading='lazy' alt='air-class'
                 src='https://web-data.zmlearn.com/image/9Ffb93eUrYMvjuomcF5rub/pic3%402x.png' />
          </div>
          <div className={ cx('img-box') }>
            <img loading='lazy' alt='air-class'
                 src='https://web-data.zmlearn.com/image/baRu3avvsPd9uHbom7TdMz/pic4%402x.png' />
          </div>
        </div>
        <div className={ cx('imgs', 'large', 'scroll-view') }>
          <div className={ cx('img-box') }>
            <img loading='lazy' alt='air-class'
                 src='https://web-data.zmlearn.com/image/t18XEkXTDadUXj6hmEVFkV/pic5%402x.png' />
          </div>
          <div className={ cx('img-box') }>
            <img loading='lazy' alt='air-class'
                 src='https://web-data.zmlearn.com/image/xrqByuvJnPmGatU1HhQ7fR/pic6%402x.png' />
          </div>
          <div className={ cx('img-box') }>
            <img loading='lazy' alt='air-class'
                 src='https://web-data.zmlearn.com/image/fsTA64TiiLEoNs9voMpCb5/pic7%402x.png' />
          </div>
        </div>
      </Section>
    </div>
  );
}
